import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  useJobsDashboardSaveMutation,
  useMutationJobDelete,
} from "../../actions/dashboardActions";
import {
  UsejobDropdowns,
  useDropdown,
  UsecitiesDropdowns,
  useStatesDropdowns,
} from "../../actions/authActions";
import { useForm } from "react-hook-form";
import { SwalAlert } from "../../components";
export default () => {
  const [loadingapplyapi, setLoadingapplyapi] = useState(false);
  const userData = useSelector((state) => state.app.userData.userData);
  const [activeTab, setActiveTab] = useState("applied-jobs"); //active-jobs
  const dispatch = useDispatch();
  const [valuejobslisting, setValueJobslisting] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [filterPopup, setFilterPopup] = useState(false);
  const [loadingapi, setLoadingapi] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedCurrentPage, setAppliedCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const queryClient = useQueryClient();
  const [isFreelance, setIsFreelance] = useState(false);
  const [filters, setFilters] = useState({});
  const [select, setSelect] = useState({
    country: "",
    states: "",
    city: "",
    salary_period: "",
    job_shift: "",
    job_type: "",
    gender: "",
    degree_level: "",
    job_experience: "",
  });
  const handleDropdwonSelect = (name, value) => {
    setSelect((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchJobsData = async ({ queryKey }) => {
    const [, page, filters] = queryKey;
    const accessToken = localStorage.getItem("accessToken");
    const params = {
      user_id: userData?.talent?.user_id,
      talent_id: userData?.talent?.id,
      ...(filters || {}), // Add filters here
    };
    const { data } = await axios.get(`${baseURL}/api/v2/job?page=${page}`, {
      params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data?.data;
  };
  const {
    data: jobsData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["jobslisting", currentPage, filters],
    queryFn: fetchJobsData,
    keepPreviousData: true,
  });
  const fetchAppliedJobData = async ({ queryKey }) => {
    const [, page, filters] = queryKey;
    const accessToken = localStorage.getItem("accessToken");
    const params = {
      talent_id: userData?.talent?.id,
      ...(filters || {}), // Add filters here
    };
    const { data } = await axios.get(
      `${baseURL}/api/v2/applied-jobs?page=${page}`,
      {
        params,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data?.data;
  };
  useEffect(() => {
    if (!isLoading) {
      setFilterPopup(false);
    }
  }, [isLoading]);
  const {
    data: appliedJobData,
    isLoading: appliedJobsisLoading,
    isError: AppliedJobsisisError,
    error: AppliedJobsError,
  } = useQuery({
    queryKey: ["appliedJobData", appliedCurrentPage, filters],
    queryFn: fetchAppliedJobData,
    keepPreviousData: true,
    enabled: activeTab === "applied-jobs",
  });

  const { has_more_pages, total_pages } = jobsData || {};
  const {
    has_more_pages: has_more_pagesapplied,
    total_pages: total_pagesapplied,
  } = appliedJobData || {};

  const mutation = useJobsDashboardSaveMutation(setLoadingapi, currentPage);
  const mutationJobDelete = useMutationJobDelete(setLoadingapi, currentPage);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      jobtitle: "",
      expirydate: "",
      postCode: "",
      salaryFrom: "",
      salaryTo: "",
      positions: "",
      description: "",
      job_shift: "",
    },
  });
  const { data: jobDropdowns } = UsejobDropdowns();
  const { data: dropdowns, isLoading: dropdownLoading } = useDropdown();
  const { data: states, isLoading: isLoadingStates } = useStatesDropdowns(
    select.country
  );
  const { data: cities, isLoading: citiesisLoading } = UsecitiesDropdowns(
    select?.states
  );
  // const experiences = jobDropdowns?.job_experience || [];
  const experiences = [
    { job_experience: null, job_experience_id: null },
    ...(jobDropdowns?.job_experience || []),
  ];
  const [index, setIndex] = useState(0);
  const rangeRef = useRef(null);
  const [tooltipPos, setTooltipPos] = useState(0);

  const handleInput = (e) => {
    const newIndex = parseInt(e.target.value);
    setIndex(newIndex);
    updateTooltipPosition(newIndex);
  };

  const updateTooltipPosition = (val) => {
    const range = rangeRef.current;
    if (range && experiences.length > 1) {
      const percent = val / (experiences.length - 1);
      const rangeWidth = range.offsetWidth;
      setTooltipPos(percent * rangeWidth);
    }
  };

  useEffect(() => {
    updateTooltipPosition(index);
  }, [index, experiences.length]);

  const selectedExperience = experiences[index]?.job_experience;
  const selectedExperienceId = experiences[index]?.job_experience_id;
  const toggleFreelance = () => {
    setIsFreelance((prev) => (prev === 1 ? 0 : 1));
  };
  const mutationJob = useMutation({
    mutationFn: async (JobData) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/v2/apply-job`,
        JobData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      const title = data.status;
      const message = data.message;
      SwalAlert(title, message, "success");
      setLoadingapplyapi(false);
      setActiveTab("applied-jobs");
      queryClient.invalidateQueries(["jobslisting", currentPage]);
      setShowPopup(false);
    },
    onError: (error) => {
      setShowPopup(false);
      setLoadingapplyapi(false);
      const message = error.response?.data?.message;
      SwalAlert("Oops...", message, "error");
    },
  });
  const handleSevedJob = (id, savedJobs) => {
    if (savedJobs) {
      setLoadingapi(true);
      setLoadingapi(id);
      const userId = localStorage.getItem("userId");
      mutationJobDelete.mutate({
        job_id: id,
        user_id: userId,
      });
    } else {
      setLoadingapi(true);
      setLoadingapi(id);
      const userId = localStorage.getItem("userId");
      mutation.mutate({
        job_id: id,
        user_id: userId,
      });
    }
  };
  const handleApplyJob = (jobId, talentId) => {
    setLoadingapplyapi(true);
    setLoadingapplyapi(jobId);
    mutationJob.mutate({
      job_id: jobId,
      talent_id: talentId,
    });
  };
  const startChatMutation = useMutation({
    mutationFn: async (startChat) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/chat/start`,
        startChat,
        {
          params: {
            sender_id: startChat?.sender_id,
            receiver_id: startChat?.receiver_id,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      navigate(`/chat/${data?.chat_head?.id}`);
      dispatch({
        type: "UPDATE_USER_CHAT_DATA",
        payload: { userChatData: data?.chat_head },
      });
      setLoading(false);
    },
    onError: (err) => {
      setLoading(false);
      SwalAlert("Oops...", err?.message, "error");
    },
  });
  const handleStartChat = (receiver_id, sender_id) => {
    setLoading(true);
    startChatMutation.mutate({ receiver_id, sender_id });
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }

  if (AppliedJobsisisError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading events: {AppliedJobsError.message}
        </p>
      </div>
    );
  }
  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "long", day: "2-digit" };
    return date.toLocaleDateString("en-GB", options);
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    const newFilters = {};

    if (select.country) newFilters["country_id[]"] = select.country;
    if (select?.states) newFilters["state_id[]"] = select?.states;
    if (select.city) newFilters["city_id[]"] = select.city;
    if (select.gender) newFilters["gender_id[]"] = select.gender;
    if (select.degree_level)
      newFilters["degree_level_id[]"] = select.degree_level;
    if (select.salary_period)
      newFilters["salary_period_id[]"] = select.salary_period;
    if (selectedExperienceId)
      newFilters["job_experience_id[]"] = selectedExperienceId;
    if (Array.isArray(data.job_shift)) {
      newFilters["job_shift_id[]"] = data.job_shift.filter(Boolean); // array
    }
    const salaryFrom = getValues("salaryFrom");
    const salaryTo = getValues("salaryTo");
    if (salaryFrom) newFilters.salary_from = salaryFrom;
    if (salaryTo) newFilters.salary_to = salaryTo;

    newFilters.is_freelance = isFreelance ? 1 : 0;

    setFilters(newFilters); // This triggers the useQuery refetch
  };
  const resetFilters = () => {
    setFilters({});
    setSelect("");
    reset();
    setIsFreelance("");
    setIndex(0);
  };
  return {
    control,
    dropdownLoading,
    isLoadingStates,
    citiesisLoading,
    handleInput,
    getValues,
    setValue,
    setFilterPopup,
    filterPopup,
    jobsData,
    appliedJobData,
    activeTab,
    setActiveTab,
    isLoading,
    appliedJobsisLoading,
    currentPage,
    setCurrentPage,
    total_pages,
    has_more_pages,
    total_pagesapplied,
    has_more_pagesapplied,
    selectedExperience,
    index,
    rangeRef,
    tooltipPos,
    experiences,
    isFreelance,
    toggleFreelance,
    select,
    showPopup,
    handleDropdwonSelect,
    states,
    cities,
    dropdowns,
    jobDropdowns,
    errors,
    register,
    handleSubmit,
    onSubmit,
    resetFilters,
    valuejobslisting,
    setValueJobslisting,
    loadingapi,
    loadingapplyapi,
    handleSevedJob,
    handleApplyJob,
    userData,
    loading,
    handleStartChat,
    formatDate,
    setAppliedCurrentPage,
    appliedCurrentPage,
    setShowPopup,
  };
};
